export const updatePlan = `
mutation updatePlan ($id: ID!, $updatedAt: String!, $input: PlanUpsert!) {
    updatePlan (id: $id, updatedAt: $updatedAt, input: $input) {
        id
        createdAt
        updatedAt
    }
}
`;
